export interface TokenPairApiResource {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface AuthenticationTokens {
  accessToken: string;
  refreshToken: string;
}

export function mapApiResourceToTokens(resource: TokenPairApiResource): AuthenticationTokens {
  return {
    accessToken: resource.access_token,
    refreshToken: resource.refresh_token,
  };
}
